{
  "name": "more-web-registration",
  "version": "0.0.10",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.14",
    "@angular/cdk": "^20.2.9",
    "@angular/common": "^20.3.0",
    "@angular/compiler": "^20.3.0",
    "@angular/core": "^20.3.0",
    "@angular/forms": "^20.3.0",
    "@angular/material": "^20.2.9",
    "@angular/material-moment-adapter": "^20.2.8",
    "@angular/platform-browser": "^20.3.0",
    "@angular/platform-browser-dynamic": "^20.3.4",
    "@angular/router": "^20.3.0",
    "@ngrx/signals": "^20.0.0-beta.0",
    "@ngrx/store": "^20.0.1",
    "@ngrx/store-devtools": "^20.0.1",
    "@wlucha/ng-country-select": "^3.0.1",
    "angularx-qrcode": "^20.0.0",
    "flag-icons": "^7.5.0",
    "jsbarcode": "^3.12.1",
    "moment": "^2.30.1",
    "ng-recaptcha-2": "^16.0.1",
    "ngx-barcode6": "^1.20.1",
    "ngx-progressbar": "^11.1.0",
    "ngx-scrollbar": "^15.0.1",
    "ngx-toastr": "^19.0.0",
    "rxjs": "~7.8.0",
    "south-african-id-parser": "^2.0.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.6",
    "@angular/build": "^20.3.4",
    "@angular/cli": "^20.3.4",
    "@angular/compiler-cli": "^20.3.0",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.2"
  }
}
